import { render, staticRenderFns } from "./TerminateNow.vue?vue&type=template&id=c406f888"
import script from "./TerminateNow.vue?vue&type=script&lang=js"
export * from "./TerminateNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports